module.exports = __webpack_public_path__ + "static/img/shop_front_4.26c110cc.jpg";